<template>
  <div class="home" bucaiji="true">
    <!-- <van-nav-bar
      title="抽题组卷"
      left-arrow
      @click-left="onClickLeft"
     
    /> -->
    <div v-if="showBack" class="fhti" @click="onTogp">
      <van-icon name="arrow-left" />
    </div>
    <div v-if="showBack" class="fhtis" @click="onTogp">返回</div>
    <div class="logos">
      <!-- <img src="../assets/sjfx.png" alt=""> -->
      <img src="../assets/logos.png" alt=""  v-if="agentCode!='0109013'"/>
    </div>

    <div v-if="outOfService" bucaiji="true">
      <img
        src="../assets/outOfService.png"
        class="outOfService"
        bucaiji="true"
      />
    </div>
    <div v-if="!outOfService" bucaiji="true">
      <div class="top"></div>
      <div class="middle" bucaiji="true">
        <div class="content" bucaiji="true">
          <img class="shu" src="../assets/shu.png" bucaiji="true" />
          <p bucaiji="true">{{ appName }}</p>
          <p class="title" bucaiji="true">{{ questionsName }}</p>
          <div class="msg" bucaiji="true">
            <div class="left" bucaiji="true">
              <img src="../assets/ti.png" bucaiji="true" />
              <span bucaiji="true">共{{ topicAmount }}题</span>
            </div>
            <div class="right" bucaiji="true">
              <img src="../assets/fen.png" bucaiji="true" />
              <span bucaiji="true">满分{{ totalScore }}分</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom" bucaiji="true">
        <p class="bottom_title" bucaiji="true" v-if="examType != 3">考试内容</p>
        <div class="lists" bucaiji="true" v-if="examType != 3">
          <div
            class="main"
            v-for="(item, index) in this.styleConfig"
            bucaiji="true"
            :key="index"
          >
            <div class="lists_left" bucaiji="true">
              <img src="../assets/tick.png" bucaiji="true" />
            </div>
            <div class="lists_middle" bucaiji="true">
              <div class="lists_wrap" bucaiji="true">
                <span bucaiji="true">{{ item.StyleName }}</span>
                <span class="fraction" bucaiji="true"
                  >{{ item.sumScore }}分</span
                >
              </div>

              <van-progress color="#FFDFDF" :percentage="item.sumScore" />
            </div>
            <div class="lists_right"></div>
          </div>
        </div>
        <div class="bt" @click="begin">
          <div
            class="aniu"
            :name="this.$selectInfo == '已交卷' ? '查看上次解析' : '开始考试'"
            data-sensors-click
            resetlocation="true"
            :newlocation="this.$selectInfo == '已交卷' ? scoreBox : ''"
          >
            {{ this.$selectInfo == "已交卷" ? "查看上次解析" : "开始考试" }}
          </div>
        </div>
      </div>
    </div>
    <!-- <img
      src="@/assets/banner.jpg"
      style="width: 100%"
      @click="onBanner"
      v-if="agentCode != '885'"
    /> -->
  </div>
</template>

<script>
var that;
import { getcs, examConfig, checkVip } from "@/api/api.js";
import { mapState } from "vuex";
import store from "@/store";
export default {
  name: "Home",
  data() {
    return {
      getLists: [],
      res: {},
      score: [],
      scoreNun: 0,
      zf: 0,
      outOfService: false,
      questionsName: "", //试卷名
      totalScore: "", //满分
      appName: "", //科目名
      styleConfig: "", //题目类型
      topicAmount: "", //题量
      zcsjde: "",
      scoreBox: "",
      showBack: false,
      examType: "",
      cptids: "",
    };
  },
  computed: {
    ...mapState(["guid"]),
    ...mapState(["userInfo"]),
    ...mapState(["configID"]),
    ...mapState(["agentCode"]),
  },

  async created() {
    that = this;
    this._cache();
    this.onExamConfig(); //获取试卷信息
    // 0109013
  },
  methods: {
    onBanner: function () {
      this.$router.push("/detail");
    },
    onTogp() {
      //  window.open('http://172.16.2.146:8080/05379001') // 新窗口打开外链接
      window.location.href = "http://172.16.2.146:8080/";
    },
    //试卷信息
    async onExamConfig() {
      let res = await this._examConfig();
      // 试卷停用或已删
      if (res.data.code == 102) {
        that.outOfService = true;
        return;
      }
      var result = res.data.data; //数据
      // styleConfig; 题目类型 points 满分
      var {
        folderID,
        appEName,
        styleConfig,
        appInfo,
        points,
        cptids,
        type,
        name,
        TestNum,
      } = result;
      var styleData = JSON.parse(result.styleData); //
      var typeScore = [];
      var styleConfigName = [];
      for (let i in styleConfig) {
        var datazf = styleData[i].Score * styleData[i].TestNum;
        typeScore.push(datazf);
        styleConfig[i]["sumScore"] = styleData[i].Score * styleData[i].TestNum;
        var a = styleConfig[i].StyleName;
        styleConfigName.push(a);
      }
      that.totalScore = points; //满分
      if (type == 3) {
        if (name) {
          let indexEnd = -1;
          if (name.indexOf("）") !== -1) {
            indexEnd = name.indexOf("）");
          } else if (name.indexOf(")")) {
            indexEnd = name.indexOf(")");
          }
          if (indexEnd !== -1) {
            name = name.slice(0, indexEnd + 1);
          }
        }
      }
      that.questionsName = name; //试卷名
      that.cptids = cptids;
      that.examType = type; //试卷类型
      that.appName = appInfo ? appInfo.cname : ""; //科目名
      that.styleConfig = styleConfig; //题目类型
      that.topicAmount = TestNum; //题量

      let pointData = {
        agentCode: this.agentCode, //代理商编号
        configName: that.questionsName, //试卷名
        configID: this.configID, //试卷id
        appName: name, //科目名
        styleConfigName: styleConfigName, //题目类型
        clientType: "抽题组卷H5",
      };
      await this.$store.dispatch("storeGetUserInfo");
      if (this.userInfo) {
        pointData.phoneNumber = this.userInfo.Tel;
        pointData.userid = this.userInfo.userID; //用户id
      }

      this.$sensors.registerPage(pointData);
      localStorage.setItem("typeScore", JSON.stringify(typeScore));
      localStorage.setItem("questionsName", that.questionsName);
      localStorage.setItem("appName", that.appName);
      localStorage.setItem("styleConfigName", styleConfigName);
      localStorage.setItem("folderID", folderID);
      localStorage.setItem("kmEName", appEName);
      localStorage.setItem("points", points);
    },
    _examConfig() {
      return new Promise((resolve, reject) => {
        var params = {
          configID: this.configID,
          TTP: "pc",
        };
        examConfig(params).then((res) => {
          resolve(res);
        });
      });
    },
    //题目
    async onGetcs() {
      if (this.$selectInfo == "已交卷") {
        this.$router.push("/answerView");
        return;
      }
      if (!this.guid) {
        this.$dialog
          .alert({
            message: "请先登录后再使用",
          })
          .then(() => {
            this.$router.push("/login");
          });
        return;
      }
      if (this.examType == 3) {
        let res = await this._checkVip();
        if (res.code == 0) {
          if (!res.data.isVip) {
            this.$dialog
              .alert({
                message:
                  "您当前未购买考前通关领航卷/领航冲刺班/私教班，请联系销售老师开通后即可答题",
              })
              .then(() => {});
            return;
          }
        } else {
          this.$toast(res.msg);
          return;
        }
      }
      var params = {
        ksbGuid: this.guid,
        configID: this.configID,
        TTP: "pc",
      };
      getcs(params).then((res) => {
        // return
        if (res.data.code == 502 || res.data.code == 501) {
          this.getLists = [];
          this.score = [];

          this.$dialog
            .alert({
              message: "登录失效，点击确认进行重新登录",
              confirmButtonText: "重新登录",
            })
            .then(() => {
              this.$router.push("/login");
            });
        } else {
          let result = res.data.data;
          if (result.test.length == 0) {
            this.$toast("暂无试题，请联系管理员!");
          }
          // if (result.test.test.length != 0) {
          //   this.getLists.push(result.test.test[0].Style);
          //   //拿到类型
          //   for (var i = 0; i < result.test.test.length; i++) {
          //     if (this.getLists.indexOf(result.test.test[i].Style) == -1) {
          //       this.getLists.push(result.test.test[i].Style);
          //     }
          //   }

          //   //拿到分数
          //   for (var t = 0; t < this.getLists.length; t++) {
          //     for (var i = 0; i < result.test.test.length; i++) {
          //       if (this.getLists[t] == result.test.test[i].Style) {
          //         this.scoreNun = this.scoreNun + result.test.test[i].Score;
          //         this.zf = this.zf + result.test.test[i].Score;
          //       }
          //     }
          //     this.score.push(this.scoreNun);
          //     this.scoreNun = 0;
          //   }
          // }

          this.$router.push("/examination");
        }
      });
    },
    _checkVip() {
      return new Promise((resolve, reject) => {
        checkVip({
          appid: this.cptids,
          vn: "157,158,855,856",
          ksbguid: this.guid,
        }).then((res) => {
          resolve(res.data);
          console.log("res", res.data.code == 401);
          if (res.data.code == 401) {
            this.$router.push({
              path: "/login",
            });
          }
        });
      });
    },
    async _cache() {
      let { gp, gpdatas, guid, isLogin, userInfoData, card_id, configID } =
        this.$route.query;
      if (gp) {
        sessionStorage.setItem("gp", gp);
        var datas = JSON.parse(gpdatas);
        localStorage.setItem("guid", guid);
      }
      if (sessionStorage.getItem("gp")) {
        this.showBack = true;
      }
      if (localStorage.getItem("scoreBox")) {
        this.scoreBox = localStorage.getItem("scoreBox");
      }
      if (isLogin) {
        var datas = JSON.parse(userInfoData);
        localStorage.setItem("guid", datas.guid);
      }

      if (typeof card_id != "undefined") {
        sessionStorage.setItem("card_id", card_id);
      }

      //清除用户选择
      if (configID) {
        if (configID != localStorage.getItem("configID")) {
          localStorage.removeItem("wjjachievementsBox");
          localStorage.removeItem("wjjtopicAnswer");
        }
      }

      //判断上次用户是否有选择过试题，
      if (localStorage.getItem("wjjachievementsBox")) {
        //判断扫码进来的试题id和缓存的试题id相等，说明和上次试卷是一样的，直接跳转
        if (configID == localStorage.getItem("configID")) {
          //判断是否交卷，0未交卷 1已交卷
          if (localStorage.getItem("Status") == 1) {
            this.$selectInfo = "已交卷";
          }
        } else {
          localStorage.removeItem("wjjachievementsBox");
          localStorage.removeItem("wjjtopicAnswer");
        }
      }
      await store.dispatch("configID", { configID });
    },
    begin() {
      this.onGetcs();
    },
  },
};
</script>

<style lang="less" scoped>
.van-progress__pivot {
  display: none;
}

.van-progress {
  background: #eff2f5;
}

.van-progress {
  width: 487px;
  height: 5px;
  margin-top: 8px;
}

.home {
  height: 100vh;
  overflow: scroll;
  .top {
    width: 100%;
    height: 504px;
    background-image: url(../assets/bj.png);
    background-size: 100% 100%;
  }

  .middle {
    display: flex;
    justify-content: center;
   margin-top: -190px;
    .content {
      width: 602px;
      height: 352px;
      opacity: 1;
      background: #fcfcfc;
      border-radius: 50px;
      text-align: center;
      box-shadow: 0 25px 180px #eaeaea;

      .shu {
        width: 78px;
        height: 78px;
        opacity: 1;
        border-radius: 25px;
        margin-top: 28px;
      }

      p {
        font-size: 30px;
        font-family: Source Han Sans CN Regular,
          Source Han Sans CN Regular-Regular;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 32px;
        letter-spacing: -1px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 20px 0 30px;
      }

      .title {
        width: 580px;
        color: #454444;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 25px;
        margin: 0 auto;
        padding: 0px;
      }

      .msg {
        display: flex;
        margin-top: 58px;
        justify-content: space-evenly;

        .left {
          img {
            width: 28px;
            height: 28px;
            margin-right: 9px;
            position: relative;
            top: 4px;
          }

          span {
            font-size: 23px;
            font-family: Source Han Sans CN Regular,
              Source Han Sans CN Regular-Regular;
            font-weight: 400;
            color: #ababab;
          }
        }

        .right {
          img {
            width: 28px;
            height: 28px;
            margin-right: 9px;
            position: relative;
            top: 5px;
          }

          span {
            font-size: 23px;
            font-family: Source Han Sans CN Regular,
              Source Han Sans CN Regular-Regular;
            font-weight: 400;
            color: #ababab;
          }
        }
      }
    }
  }

  .bottom {
    width: 100%;

    .bottom_title {
      margin-top: 43px;
      margin-left: 75px;
      font-size: 30px;
      font-family: Source Han Sans CN Regular,
        Source Han Sans CN Regular-Regular;
      font-weight: 400;
      color: #1a1a1a;
    }

    .lists {
      .main {
        width: 602px;
        // height: 92px;
        display: flex;
        margin: auto;
        background-color: #ffffff;
        padding: 20px 0;
        margin-bottom: 15px;
        box-shadow: 0 0 150px #eae8e8;
        border-radius: 25px;

        .lists_left {
          margin-left: 23px;
          margin-right: 11px;

          img {
            width: 53px;
            height: 53px;
            background-size: 100% 100%;
          }
        }

        .lists_middle {
          .lists_wrap {
            display: flex;
            justify-content: space-between;

            span {
              font-size: 27px;
              font-family: Source Han Sans CN Regular,
                Source Han Sans CN Regular-Regular;
              font-weight: 400;
              color: #1a1a1a;
              line-height: 32px;
              padding: 0px;
              margin: 0px;
            }

            .fraction {
              font-size: 23px;
              font-family: Source Han Sans CN Regular,
                Source Han Sans CN Regular-Regular;
              font-weight: 400;
              color: #acacac;
            }
          }
        }

        .lists_right {
        }
      }
    }

    .bt {
      width: 100%;
      justify-content: center;
      display: flex;
      margin: 62px 0;

      .aniu {
        width: 338px;
        height: 82px;
        background: #61b3ff;
        border-radius: 25px;
        font-size: 29px;
        font-family: Source Han Sans CN Regular,
          Source Han Sans CN Regular-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 82px;
      }
    }
  }
}

.outOfService {
  width: 750px;
}
.logos {
  position: absolute;
  top: 30px;
  right: 30px;
}
.logos img {
  width: 220px;
  height: 85px;
}
.fhti {
  position: absolute;
  top: 30px;
  left: 40px;
  font-size: 50px;
  color: #fff;

  display: flex;
  align-items: center;
  height: 60px;
}
.fhtis {
  position: absolute;
  top: 28px;
  left: 90px;
  font-size: 30px;
  color: #fff;

  display: flex;
  align-items: center;
  height: 60px;
}
.home /deep/ .van-progress__pivot {
  top: -1000000000000px;
}
</style>
